import { AfterViewInit, Directive, ElementRef, inject, OnDestroy, Renderer2 } from '@angular/core';

@Directive({
  selector: '[workUiAutofocus]',
  standalone: true,
})
export class AutofocusDirective implements AfterViewInit, OnDestroy {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly renderer2 = inject(Renderer2);

  private focusCheckInterval: number | null = null;

  ngAfterViewInit(): void {
    const focusableElement = this.getFocusableElement();

    if (focusableElement) {
      this.focusCheckInterval = window.setInterval(() => {
        if (document.activeElement !== focusableElement) {
          focusableElement.focus();
        } else {
          this.clearFocusInterval(); // Stop interval once focused
        }
      }, 50); // Check every 50ms
    } else {
      console.warn('[workUiAutofocus] No focusable element found inside the host component.');
    }
  }

  ngOnDestroy(): void {
    this.clearFocusInterval(); // Ensure cleanup if directive is destroyed
  }

  private getFocusableElement(): HTMLInputElement | HTMLTextAreaElement | null {
    const nativeElement = this.elementRef.nativeElement;

    // If the host element itself is focusable (custom components)
    if (nativeElement.tagName === 'INPUT' || nativeElement.tagName === 'TEXTAREA') {
      return nativeElement as HTMLInputElement | HTMLTextAreaElement;
    }

    // Search for <input> or <textarea> inside the host component
    const focusableElement = nativeElement.querySelector('input, textarea');
    return focusableElement as HTMLInputElement | HTMLTextAreaElement | null;
  }

  private clearFocusInterval(): void {
    if (this.focusCheckInterval !== null) {
      clearInterval(this.focusCheckInterval);
      this.focusCheckInterval = null;
    }
  }
}
